module.exports = __webpack_public_path__ + "nc_static/media/file-docx.ae6ee147.svg";